import React, { Fragment } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import G01MainHeader from "./guestappcomponents/G01MainHeader/G01MainHeader";
import G02MainFooter from "./guestappcomponents/G02MainFooter/G02MainFooter";
import P01HomePage from "./guestapppages/P01HomePage/P01HomePage";
import P02LinkInBio from "./guestapppages/P02LinkInBio/P02LinkInBio";

const GuestApp = () => {
  const { pathname } = useLocation();

  console.log(pathname);
  return (
    <Fragment>
      {/* Layout persistente */}
      {pathname !== "/ig" && <G01MainHeader />}

      {/* Rutas del guest app */}
      <Routes>
        <Route index element={<P01HomePage />} />
        <Route path="/ig" element={<P02LinkInBio />} />
      </Routes>

      <G02MainFooter />
    </Fragment>
  );
};

export default GuestApp;
